//
// Copyright (c) 2008-2025 Barry E. Mapen All Rights Reserved
//
import 'bootstrap-icons/font/bootstrap-icons.css';

export function BootstrapIcon({
    icon,
    variant,
    onClick,
}) {

    if (variant) {
        var varClass = `text-${variant}`
    }
    return(
        <i className={`bi bi-${icon} ${varClass}`} onClick={onClick}></i>
    );
}
